import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { ActiveLinkProvider } from './components/ActiveLinkContext';
import FirebaseContext, { firebaseServices } from './views/firebase/firebasecontext'; // Use named imports


const root = ReactDOM.createRoot(document.getElementById('root'));
//console.log("firebase: " + firebaseServices); // Ensure it outputs initialized Firebase services.

root.render(
  <ErrorBoundary>
    <FirebaseContext.Provider value={firebaseServices}>
      <ActiveLinkProvider>
        <Router>
            <App />
        </Router>
      </ActiveLinkProvider>
    </FirebaseContext.Provider>
  </ErrorBoundary>
);
